// import { formatCountry } from "./Helper";

const SidebarConfig = [
    {
        title: 'Information',
        path: 'information',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11 17h2v-6h-2zm1-8a1.25 1.25 0 1 0-1.25-1.25A1.25 1.25 0 0 0 12 9m0 13a10 10 0 1 1 10-10a10 10 0 0 1-10 10"/></svg>,
        activeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11 17h2v-6h-2zm1-8a1.25 1.25 0 1 0-1.25-1.25A1.25 1.25 0 0 0 12 9m0 13a10 10 0 1 1 10-10a10 10 0 0 1-10 10"/></svg>,
        module: "INFORMATION",
    },
    {
        title: 'Homepage',
        path: 'dashboard',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81zM12 3L2 12h3v8h6v-6h2v6h6v-8h3" /></svg>,
        activeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81zM12 3L2 12h3v8h6v-6h2v6h6v-8h3" /></svg>,
        module: "HOMEPAGE"
    },
    {
        title: 'Company Info',
        path: 'company-info',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.9999 11C13.2867 11 14.3299 9.95681 14.3299 8.66998C14.3299 7.38316 13.2867 6.34003 11.9999 6.34003C10.7131 6.34003 9.66992 7.38316 9.66992 8.66998C9.66992 9.95681 10.7131 11 11.9999 11Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 16.66C16 14.86 14.21 13.4 12 13.4C9.79 13.4 8 14.86 8 16.66" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ,
        activeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17.5099 3.85L11.5699 0.42C10.5999 -0.14 9.39992 -0.14 8.41992 0.42L2.48992 3.85C1.51992 4.41 0.919922 5.45 0.919922 6.58V13.42C0.919922 14.54 1.51992 15.58 2.48992 16.15L8.42992 19.58C9.39992 20.14 10.5999 20.14 11.5799 19.58L17.5199 16.15C18.4899 15.59 19.0899 14.55 19.0899 13.42V6.58C19.0799 5.45 18.4799 4.42 17.5099 3.85ZM9.99992 5.34C11.2899 5.34 12.3299 6.38 12.3299 7.67C12.3299 8.96 11.2899 10 9.99992 10C8.70992 10 7.66992 8.96 7.66992 7.67C7.66992 6.39 8.70992 5.34 9.99992 5.34ZM12.6799 14.66H7.31992C6.50992 14.66 6.03992 13.76 6.48992 13.09C7.16992 12.08 8.48992 11.4 9.99992 11.4C11.5099 11.4 12.8299 12.08 13.5099 13.09C13.9599 13.75 13.4799 14.66 12.6799 14.66Z" fill="#ECBB33" />
        </svg>,
        module: "COMPANY"
    },
    {
        title: 'Profile Details',
        path: 'profile',
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M16 9a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-2 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0" /><path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1M3 12c0 2.09.713 4.014 1.908 5.542A8.99 8.99 0 0 1 12.065 14a8.98 8.98 0 0 1 7.092 3.458A9 9 0 1 0 3 12m9 9a8.96 8.96 0 0 1-5.672-2.012A6.99 6.99 0 0 1 12.065 16a6.99 6.99 0 0 1 5.689 2.92A8.96 8.96 0 0 1 12 21" /></g></svg>,
        activeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512"><path fill="currentColor" fill-rule="evenodd" d="M256 42.667A213.333 213.333 0 0 1 469.334 256c0 117.821-95.513 213.334-213.334 213.334c-117.82 0-213.333-95.513-213.333-213.334C42.667 138.18 138.18 42.667 256 42.667m21.334 234.667h-42.667c-52.815 0-98.158 31.987-117.715 77.648c30.944 43.391 81.692 71.685 139.048 71.685s108.104-28.294 139.049-71.688c-19.557-45.658-64.9-77.645-117.715-77.645M256 106.667c-35.346 0-64 28.654-64 64s28.654 64 64 64s64-28.654 64-64s-28.653-64-64-64" /></svg>,
        module: "PROFILE"
    },
    {
        title: 'My Products',
        path: 'products',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 8.27V4.23C22 2.64 21.36 2 19.77 2H15.73C14.14 2 13.5 2.64 13.5 4.23V8.27C13.5 9.86 14.14 10.5 15.73 10.5H19.77C21.36 10.5 22 9.86 22 8.27Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15 15.5H21" stroke="#475569" stroke-width="1.5" stroke-linecap="round" />
            <path d="M15 19.5H21" stroke="#475569" stroke-width="1.5" stroke-linecap="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H21C21.41 14.75 21.75 15.09 21.75 15.5C21.75 15.91 21.41 16.25 21 16.25Z" fill="#ECBB33" />
            <path d="M21 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z" fill="#ECBB33" />
            <path d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z" fill="#ECBB33" />
            <path d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z" fill="#ECBB33" />
            <path d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z" fill="#ECBB33" />
        </svg>,

        module: "PRODUCTS"
    },
    {
        title: 'Bookings',
        path: 'bookings',
        // icon: <i className="bi bi-patch-check"></i>,
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.38086 12L10.7909 14.42L15.6209 9.57999" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.7509 2.45001C11.4409 1.86001 12.5709 1.86001 13.2709 2.45001L14.8509 3.81001C15.1509 4.07001 15.7109 4.28001 16.1109 4.28001H17.8109C18.8709 4.28001 19.7409 5.15001 19.7409 6.21001V7.91001C19.7409 8.30001 19.9509 8.87001 20.2109 9.17001L21.5709 10.75C22.1609 11.44 22.1609 12.57 21.5709 13.27L20.2109 14.85C19.9509 15.15 19.7409 15.71 19.7409 16.11V17.81C19.7409 18.87 18.8709 19.74 17.8109 19.74H16.1109C15.7209 19.74 15.1509 19.95 14.8509 20.21L13.2709 21.57C12.5809 22.16 11.4509 22.16 10.7509 21.57L9.17086 20.21C8.87086 19.95 8.31086 19.74 7.91086 19.74H6.18086C5.12086 19.74 4.25086 18.87 4.25086 17.81V16.1C4.25086 15.71 4.04086 15.15 3.79086 14.85L2.44086 13.26C1.86086 12.57 1.86086 11.45 2.44086 10.76L3.79086 9.17001C4.04086 8.87001 4.25086 8.31001 4.25086 7.92001V6.20001C4.25086 5.14001 5.12086 4.27001 6.18086 4.27001H7.91086C8.30086 4.27001 8.87086 4.06001 9.17086 3.80001L10.7509 2.45001Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5599 10.74L20.1999 9.16C19.9399 8.86 19.7299 8.3 19.7299 7.9V6.2C19.7299 5.14 18.8599 4.27 17.7999 4.27H16.0999C15.7099 4.27 15.1399 4.06 14.8399 3.8L13.2599 2.44C12.5699 1.85 11.4399 1.85 10.7399 2.44L9.16988 3.81C8.86988 4.06 8.29988 4.27 7.90988 4.27H6.17988C5.11988 4.27 4.24988 5.14 4.24988 6.2V7.91C4.24988 8.3 4.03988 8.86 3.78988 9.16L2.43988 10.75C1.85988 11.44 1.85988 12.56 2.43988 13.25L3.78988 14.84C4.03988 15.14 4.24988 15.7 4.24988 16.09V17.8C4.24988 18.86 5.11988 19.73 6.17988 19.73H7.90988C8.29988 19.73 8.86988 19.94 9.16988 20.2L10.7499 21.56C11.4399 22.15 12.5699 22.15 13.2699 21.56L14.8499 20.2C15.1499 19.94 15.7099 19.73 16.1099 19.73H17.8099C18.8699 19.73 19.7399 18.86 19.7399 17.8V16.1C19.7399 15.71 19.9499 15.14 20.2099 14.84L21.5699 13.26C22.1499 12.57 22.1499 11.43 21.5599 10.74ZM16.1599 10.11L11.3299 14.94C11.1899 15.08 10.9999 15.16 10.7999 15.16C10.5999 15.16 10.4099 15.08 10.2699 14.94L7.84988 12.52C7.55988 12.23 7.55988 11.75 7.84988 11.46C8.13988 11.17 8.61988 11.17 8.90988 11.46L10.7999 13.35L15.0999 9.05C15.3899 8.76 15.8699 8.76 16.1599 9.05C16.4499 9.34 16.4499 9.82 16.1599 10.11Z" fill="#ECBB33" />
        </svg>,

        module: "BOOKINGS"

    },
    {
        title: 'Custom Tours',
        path: '/custom-tours',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.5L8 4L16 6.5L21 4V17.5L16 20L8 17.5L3 20V6.5Z"
                    stroke="#475569"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 4V17.5"
                    stroke="#475569"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 6.5V20"
                    stroke="#475569"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        ),
        activeIcon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.5L8 4L16 6.5L21 4V17.5L16 20L8 17.5L3 20V6.5Z"
                    fill="#ECBB33"
                    stroke="#ECBB33"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 4V17.5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M16 6.5V20"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
        ),
    },
    {
        title: 'Availability',
        path: 'availability',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2V5" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 2V5" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.5 9.09H20.5" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.9945 13.7H12.0035" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.29529 13.7H8.30427" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.29529 16.7H8.30427" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z" fill="#ECBB33" />
            <path d="M20 9.84H4C3.45 9.84 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.84 20 9.84ZM9.21 18.21C9.11 18.3 9 18.37 8.88 18.42C8.76 18.47 8.63 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C8 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 8 16.63 8.12 16.58C8.36 16.48 8.64 16.48 8.88 16.58C9 16.63 9.11 16.7 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.42 14.38C9.37 14.5 9.3 14.61 9.21 14.71C9.11 14.8 9 14.87 8.88 14.92C8.76 14.97 8.63 15 8.5 15C8.37 15 8.24 14.97 8.12 14.92C8 14.87 7.89 14.8 7.79 14.71C7.7 14.61 7.63 14.5 7.58 14.38C7.53 14.26 7.5 14.13 7.5 14C7.5 13.87 7.53 13.74 7.58 13.62C7.63 13.5 7.7 13.39 7.79 13.29C7.89 13.2 8 13.13 8.12 13.08C8.36 12.98 8.64 12.98 8.88 13.08C9 13.13 9.11 13.2 9.21 13.29C9.3 13.39 9.37 13.5 9.42 13.62C9.47 13.74 9.5 13.87 9.5 14C9.5 14.13 9.47 14.26 9.42 14.38ZM12.71 14.71C12.61 14.8 12.5 14.87 12.38 14.92C12.26 14.97 12.13 15 12 15C11.87 15 11.74 14.97 11.62 14.92C11.5 14.87 11.39 14.8 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.39 13.2 11.5 13.13 11.62 13.08C11.86 12.97 12.14 12.97 12.38 13.08C12.5 13.13 12.61 13.2 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71Z" fill="#ECBB33" />
        </svg>,
        module: "AVAILABILITY"

    },
    // {
    //     title: 'Inbox',
    //     path: 'inbox',
    //     icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    //     <path d="M7 8H17" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //     <path d="M7 13H13" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    //     </svg>
    // },
    {
        title: 'Settings',
        path: 'settings',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 12.88V11.12C2 10.08 2.85 9.22 3.9 9.22C5.71 9.22 6.45 7.94 5.54 6.37C5.02 5.47 5.33 4.3 6.24 3.78L7.97 2.79C8.76 2.32 9.78 2.6 10.25 3.39L10.36 3.58C11.26 5.15 12.74 5.15 13.65 3.58L13.76 3.39C14.23 2.6 15.25 2.32 16.04 2.79L17.77 3.78C18.68 4.3 18.99 5.47 18.47 6.37C17.56 7.94 18.3 9.22 20.11 9.22C21.15 9.22 22.01 10.07 22.01 11.12V12.88C22.01 13.92 21.16 14.78 20.11 14.78C18.3 14.78 17.56 16.06 18.47 17.63C18.99 18.54 18.68 19.7 17.77 20.22L16.04 21.21C15.25 21.68 14.23 21.4 13.76 20.61L13.65 20.42C12.75 18.85 11.27 18.85 10.36 20.42L10.25 20.61C9.78 21.4 8.76 21.68 7.97 21.21L6.24 20.22C5.33 19.7 5.02 18.53 5.54 17.63C6.45 16.06 5.71 14.78 3.9 14.78C2.85 14.78 2 13.92 2 12.88Z" stroke="#475569" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1 9.22C18.29 9.22 17.55 7.94 18.45 6.37C18.97 5.46 18.66 4.3 17.75 3.78L16.02 2.79C15.23 2.32 14.21 2.6 13.74 3.39L13.63 3.58C12.73 5.15 11.25 5.15 10.34 3.58L10.23 3.39C9.78 2.6 8.76 2.32 7.97 2.79L6.24 3.78C5.33 4.3 5.02 5.47 5.54 6.38C6.45 7.94 5.71 9.22 3.9 9.22C2.86 9.22 2 10.07 2 11.12V12.88C2 13.92 2.85 14.78 3.9 14.78C5.71 14.78 6.45 16.06 5.54 17.63C5.02 18.54 5.33 19.7 6.24 20.22L7.97 21.21C8.76 21.68 9.78 21.4 10.25 20.61L10.36 20.42C11.26 18.85 12.74 18.85 13.65 20.42L13.76 20.61C14.23 21.4 15.25 21.68 16.04 21.21L17.77 20.22C18.68 19.7 18.99 18.53 18.47 17.63C17.56 16.06 18.3 14.78 20.11 14.78C21.15 14.78 22.01 13.93 22.01 12.88V11.12C22 10.08 21.15 9.22 20.1 9.22ZM12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25Z" fill="#ECBB33" />
        </svg>


    },
    {
        title: 'Guides',
        path: 'guides',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6C10.2 4.9 8.13 4.25 6 4.25C4.9 4.25 3.85 4.42 2.88 4.74C2.37 4.91 2 5.39 2 5.93V18.07C2 18.86 2.74 19.43 3.5 19.2C4.3 18.96 5.15 18.84 6 18.84C8.13 18.84 10.2 19.49 12 20.6" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 6C13.8 4.9 15.87 4.25 18 4.25C19.1 4.25 20.15 4.42 21.12 4.74C21.63 4.91 22 5.39 22 5.93V18.07C22 18.86 21.26 19.43 20.5 19.2C19.7 18.96 18.85 18.84 18 18.84C15.87 18.84 13.8 19.49 12 20.6" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 6V20.6" stroke="#475569" stroke-width="1.5" stroke-linecap="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.95 4.9C20.02 4.59 19.02 4.43 18 4.43C15.88 4.43 13.81 5.05 12 6.2C10.19 5.05 8.12 4.43 6 4.43C4.98 4.43 3.98 4.59 3.05 4.9C2.43 5.11 2 5.69 2 6.35V17.91C2 18.82 2.84 19.48 3.72 19.24C4.45 19.04 5.22 18.93 6 18.93C8.15 18.93 10.24 19.63 12 20.93C13.76 19.63 15.85 18.93 18 18.93C18.78 18.93 19.55 19.04 20.28 19.24C21.16 19.48 22 18.82 22 17.91V6.35C22 5.69 21.57 5.11 20.95 4.9Z" fill="#ECBB33" />
        </svg>


    },
    {
        title: 'Finance',
        path: 'finance',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.04 13.55C17.62 13.96 17.38 14.55 17.44 15.18C17.53 16.26 18.52 17.05 19.6 17.05H21.5V18.24C21.5 20.31 19.81 22 17.74 22H6.26C4.19 22 2.5 20.31 2.5 18.24V11.51C2.5 9.44001 4.19 7.75 6.26 7.75H17.74C19.81 7.75 21.5 9.44001 21.5 11.51V12.95H19.48C18.92 12.95 18.41 13.17 18.04 13.55Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 12.41V7.84004C2.5 6.65004 3.23 5.59 4.34 5.17L12.28 2.17C13.52 1.7 14.85 2.62003 14.85 3.95003V7.75002" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22.5588 13.9702V16.0302C22.5588 16.5802 22.1188 17.0302 21.5588 17.0502H19.5988C18.5188 17.0502 17.5288 16.2602 17.4388 15.1802C17.3788 14.5502 17.6188 13.9602 18.0388 13.5502C18.4088 13.1702 18.9188 12.9502 19.4788 12.9502H21.5588C22.1188 12.9702 22.5588 13.4202 22.5588 13.9702Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 12H14" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.85 3.94999V7.74999H13.35V3.94999C13.35 3.67999 13.11 3.54999 12.95 3.54999C12.9 3.54999 12.85 3.55999 12.8 3.57999L4.87 6.56999C4.34 6.76999 4 7.26999 4 7.83999V8.50999C3.09 9.18999 2.5 10.28 2.5 11.51V7.83999C2.5 6.64999 3.23 5.58999 4.34 5.16999L12.28 2.16999C12.5 2.08999 12.73 2.04999 12.95 2.04999C13.95 2.04999 14.85 2.85999 14.85 3.94999Z" fill="#ECBB33" />
            <path d="M21.5002 14.5V15.5C21.5002 15.77 21.2902 15.99 21.0102 16H19.5502C19.0202 16 18.5402 15.61 18.5002 15.09C18.4702 14.78 18.5902 14.49 18.7902 14.29C18.9702 14.1 19.2202 14 19.4902 14H21.0002C21.2902 14.01 21.5002 14.23 21.5002 14.5Z" fill="#ECBB33" />
            <path d="M19.48 12.95H20.5C21.05 12.95 21.5 12.5 21.5 11.95V11.51C21.5 9.44 19.81 7.75 17.74 7.75H6.26C5.41 7.75 4.63 8.03 4 8.51C3.09 9.19 2.5 10.28 2.5 11.51V18.24C2.5 20.31 4.19 22 6.26 22H17.74C19.81 22 21.5 20.31 21.5 18.24V18.05C21.5 17.5 21.05 17.05 20.5 17.05H19.63C18.67 17.05 17.75 16.46 17.5 15.53C17.29 14.77 17.54 14.04 18.04 13.55C18.41 13.17 18.92 12.95 19.48 12.95ZM14 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H14C14.41 11.25 14.75 11.59 14.75 12C14.75 12.41 14.41 12.75 14 12.75Z" fill="#ECBB33" />
        </svg>
        ,

        items: [
            {
                title: 'Payments',
                path: 'finance/payments',
                module: "PAYMENTS"

            },
            {
                title: 'Withdrawals',
                path: 'finance/withdrawals',
                module: "WITHDRAWALS"
            },
            {
                title: 'Settings',
                path: 'finance/settings',
                module: "PAYMENTSETTINGS"
            }
        ],
        module: "FINANCE"

    },
    {
        title: 'Team',
        path: 'team',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.16055 10.87C9.06055 10.86 8.94055 10.86 8.83055 10.87C6.45055 10.79 4.56055 8.84 4.56055 6.44C4.56055 3.99 6.54055 2 9.00055 2C11.4505 2 13.4405 3.99 13.4405 6.44C13.4305 8.84 11.5405 10.79 9.16055 10.87Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.4093 4C18.3493 4 19.9093 5.57 19.9093 7.5C19.9093 9.39 18.4093 10.93 16.5393 11C16.4593 10.99 16.3693 10.99 16.2793 11" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.1607 14.56C1.7407 16.18 1.7407 18.82 4.1607 20.43C6.9107 22.27 11.4207 22.27 14.1707 20.43C16.5907 18.81 16.5907 16.17 14.1707 14.56C11.4307 12.73 6.9207 12.73 4.1607 14.56Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z" fill="#ECBB33" />
            <path d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z" fill="#ECBB33" />
            <path d="M19.9899 7.33999C20.1499 9.27999 18.7699 10.98 16.8599 11.21C16.8499 11.21 16.8499 11.21 16.8399 11.21H16.8099C16.7499 11.21 16.6899 11.21 16.6399 11.23C15.6699 11.28 14.7799 10.97 14.1099 10.4C15.1399 9.47999 15.7299 8.09999 15.6099 6.59999C15.5399 5.78999 15.2599 5.04999 14.8399 4.41999C15.2199 4.22999 15.6599 4.10999 16.1099 4.06999C18.0699 3.89999 19.8199 5.35999 19.9899 7.33999Z" fill="#ECBB33" />
            <path d="M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z" fill="#ECBB33" />
        </svg>,

        module: "TEAM"
    },
    // {
    //     title: 'Tool',
    //     path: 'tool',
    //     icon: <svg className="nav-icon me-2" width="18px" height="18px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="#94a3b8"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path fillRule="evenodd" clipRule="evenodd" d="M14.773 3.485l-.78-.184-2.108 2.096-1.194-1.216 2.056-2.157-.18-.792a4.42 4.42 0 0 0-1.347-.228 3.64 3.64 0 0 0-1.457.28 3.824 3.824 0 0 0-1.186.84 3.736 3.736 0 0 0-.875 1.265 3.938 3.938 0 0 0 0 2.966 335.341 335.341 0 0 0-6.173 6.234c-.21.275-.31.618-.284.963a1.403 1.403 0 0 0 .464.967c.124.135.272.247.437.328.17.075.353.118.538.127.316-.006.619-.126.854-.337 1.548-1.457 4.514-4.45 6.199-6.204.457.194.948.294 1.444.293a3.736 3.736 0 0 0 2.677-1.133 3.885 3.885 0 0 0 1.111-2.73 4.211 4.211 0 0 0-.196-1.378zM2.933 13.928a.31.31 0 0 1-.135.07.437.437 0 0 1-.149 0 .346.346 0 0 1-.144-.057.336.336 0 0 1-.114-.11c-.14-.143-.271-.415-.14-.568 1.37-1.457 4.191-4.305 5.955-6.046.1.132.21.258.328.376.118.123.245.237.38.341-1.706 1.75-4.488 4.564-5.98 5.994zm11.118-9.065c.002.765-.296 1.5-.832 2.048a2.861 2.861 0 0 1-4.007 0 2.992 2.992 0 0 1-.635-3.137A2.748 2.748 0 0 1 10.14 2.18a2.76 2.76 0 0 1 1.072-.214h.254L9.649 3.839v.696l1.895 1.886h.66l1.847-1.816v.258zM3.24 6.688h1.531l.705.717.678-.674-.665-.678V6.01l.057-1.649-.22-.437-2.86-1.882-.591.066-.831.849-.066.599 1.838 2.918.424.215zm-.945-3.632L4.609 4.58 4.57 5.703H3.494L2.002 3.341l.293-.285zm7.105 6.96l.674-.673 3.106 3.185a1.479 1.479 0 0 1 0 2.039 1.404 1.404 0 0 1-1.549.315 1.31 1.31 0 0 1-.437-.315l-3.142-3.203.679-.678 3.132 3.194a.402.402 0 0 0 .153.105.477.477 0 0 0 .359 0 .403.403 0 0 0 .153-.105.436.436 0 0 0 .1-.153.525.525 0 0 0 .036-.184.547.547 0 0 0-.035-.184.436.436 0 0 0-.1-.153L9.4 10.016z"></path></g></svg>
    // },
    {
        title: 'Privacy',
        path: 'privacy',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9998 22.7501C11.7598 22.7501 11.5199 22.7201 11.2899 22.6501C6.09986 21.2201 2.33984 16.37 2.33984 11.11V6.72003C2.33984 5.60003 3.14985 4.39008 4.18985 3.96008L9.75986 1.68005C11.2099 1.09005 12.7998 1.09005 14.2398 1.68005L19.8098 3.96008C20.8498 4.39008 21.6599 5.60003 21.6599 6.72003V11.11C21.6599 16.36 17.8898 21.2101 12.7098 22.6501C12.4798 22.7201 12.2398 22.7501 11.9998 22.7501ZM11.9998 2.75006C11.4298 2.75006 10.8698 2.86007 10.3298 3.08007L4.75986 5.36004C4.27986 5.56004 3.83984 6.21004 3.83984 6.73004V11.1201C3.83984 15.7101 7.13985 19.9501 11.6898 21.2101C11.8898 21.2701 12.1098 21.2701 12.3098 21.2101C16.8598 19.9501 20.1599 15.7101 20.1599 11.1201V6.73004C20.1599 6.21004 19.7198 5.56004 19.2398 5.36004L13.6699 3.08007C13.1299 2.86007 12.5698 2.75006 11.9998 2.75006Z" fill="#475569" />
            <path d="M12 13.25C10.48 13.25 9.25 12.02 9.25 10.5C9.25 8.98 10.48 7.75 12 7.75C13.52 7.75 14.75 8.98 14.75 10.5C14.75 12.02 13.52 13.25 12 13.25ZM12 9.25C11.31 9.25 10.75 9.81 10.75 10.5C10.75 11.19 11.31 11.75 12 11.75C12.69 11.75 13.25 11.19 13.25 10.5C13.25 9.81 12.69 9.25 12 9.25Z" fill="#475569" />
            <path d="M12 16.25C11.59 16.25 11.25 15.91 11.25 15.5V12.5C11.25 12.09 11.59 11.75 12 11.75C12.41 11.75 12.75 12.09 12.75 12.5V15.5C12.75 15.91 12.41 16.25 12 16.25Z" fill="#475569" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9098 11.12V6.73001C20.9098 5.91001 20.2898 4.98001 19.5198 4.67001L13.9498 2.39001C12.6998 1.88001 11.2898 1.88001 10.0398 2.39001L4.46984 4.67001C3.70984 4.98001 3.08984 5.91001 3.08984 6.73001V11.12C3.08984 16.01 6.63984 20.59 11.4898 21.93C11.8198 22.02 12.1798 22.02 12.5098 21.93C17.3598 20.59 20.9098 16.01 20.9098 11.12ZM12.7498 12.87V15.5C12.7498 15.91 12.4098 16.25 11.9998 16.25C11.5898 16.25 11.2498 15.91 11.2498 15.5V12.87C10.2398 12.55 9.49984 11.61 9.49984 10.5C9.49984 9.12001 10.6198 8.00001 11.9998 8.00001C13.3798 8.00001 14.4998 9.12001 14.4998 10.5C14.4998 11.62 13.7598 12.55 12.7498 12.87Z" fill="#ECBB33" />
        </svg>
        ,
        module: "PRIVACY"
    },
    {
        title: 'Boost Visibility',
        path: 'plans',
        icon: <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M6 14h2m3 0h5M3 7v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 7V17C20 18.1 19.1 19 18 19H6C4.9 19 4 18.1 4 17V7C4 5.9 4.9 5 6 5H18C19.1 5 20 5.9 20 7ZM21 10H3V11H21V10ZM8 14H6V15H8V14ZM11 14H9V15H11V14ZM16 14H14V15H16V14Z" fill="#ECBB33" />
        </svg>
        ,
        module: "PLANS"
    },
    {
        title: 'Temporary Discounts',
        path: 'temporary-discounts',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.32 11.68L12.32 2.68C11.96 2.32 11.45 2.13 10.94 2.18L5.07 2.69C4.31 2.75 3.7 3.36 3.64 4.12L3.13 9.99C3.08 10.5 3.27 11.01 3.63 11.37L12.63 20.37C13.41 21.15 14.68 21.15 15.46 20.37L21.32 14.51C22.1 13.73 22.1 12.46 21.32 11.68Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.32 11.68L12.32 2.68C11.96 2.32 11.45 2.13 10.94 2.18L5.07 2.69C4.31 2.75 3.7 3.36 3.64 4.12L3.13 9.99C3.08 10.5 3.27 11.01 3.63 11.37L12.63 20.37C13.41 21.15 14.68 21.15 15.46 20.37L21.32 14.51C22.1 13.73 22.1 12.46 21.32 11.68ZM8.5 10C7.67 10 7 9.33 7 8.5C7 7.67 7.67 7 8.5 7C9.33 7 10 7.67 10 8.5C10 9.33 9.33 10 8.5 10Z" fill="#ECBB33" />
        </svg>,
        module: "PROMOTION"
    },
    {
        title: 'Support',
        path: 'support-portal',
        handoff: true,
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 14V12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12V14" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6 19H5C3.9 19 3 18.1 3 17V15C3 13.9 3.9 13 5 13H6V19Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 19H19C20.1 19 21 18.1 21 17V15C21 13.9 20.1 13 19 13H18V19Z" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 17V18C20 20 19 21 16 21H13" stroke="#475569" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        activeIcon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 14V12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12V14" stroke="#ECBB33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6 19H5C3.9 19 3 18.1 3 17V15C3 13.9 3.9 13 5 13H6V19Z" stroke="#ECBB33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 19H19C20.1 19 21 18.1 21 17V15C21 13.9 20.1 13 19 13H18V19Z" stroke="#ECBB33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 17V18C20 20 19 21 16 21H13" stroke="#ECBB33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    }

];

const DescriptionLanguage = ['english', 'french', 'german', 'italian', 'portuguese', 'spanish']

const Language = {
    'Abkhaz': 'ab',
    'Acehnese': 'ace',
    'Acholi': 'ach',
    'Afrikaans': 'af',
    'Albanian': 'sq',
    'Alur': 'alz',
    'Amharic': 'am',
    'Arabic': 'ar',
    'Armenian': 'hy',
    'Assamese': 'as',
    'Awadhi': 'awa',
    'Aymara': 'ay',
    'Azerbaijani': 'az',
    'Balinese': 'ban',
    'Bambara': 'bm',
    'Bashkir': 'ba',
    'Basque': 'eu',
    'Batak Karo': 'btx',
    'Batak Simalungun': 'bts',
    'Batak Toba': 'bbc',
    'Belarusian': 'be',
    'Bemba': 'bem',
    'Bengali': 'bn',
    'Betawi': 'bew',
    'Bhojpuri': 'bho',
    'Bikol': 'bik',
    'Bosnian': 'bs',
    'Breton': 'br',
    'Bulgarian': 'bg',
    'Buryat': 'bua',
    'Cantonese': 'yue',
    'Catalan': 'ca',
    'Cebuano': 'ceb',
    'Chichewa (Nyanja)': 'ny',
    'Chinese (Simplified)': 'zh-CN',
    'Chinese (Traditional)': 'zh-TW',
    'Chuvash': 'cv',
    'Corsican': 'co',
    'Crimean Tatar': 'crh',
    'Croatian': 'hr',
    'Czech': 'cs',
    'Danish': 'da',
    'Dinka': 'din',
    'Divehi': 'dv',
    'Dogri': 'doi',
    'Dombe': 'dov',
    'Dutch': 'nl',
    'Dzongkha': 'dz',
    'English': 'en',
    'Esperanto': 'eo',
    'Estonian': 'et',
    'Ewe': 'ee',
    'Fijian': 'fj',
    'Filipino (Tagalog)': 'fil',
    'Finnish': 'fi',
    'French': 'fr',
    'French (French)': 'fr-FR',
    'French (Canadian)': 'fr-CA',
    'Frisian': 'fy',
    'Fulfulde': 'ff',
    'Ga': 'gaa',
    'Galician': 'gl',
    'Ganda (Luganda)': 'lg',
    'Georgian': 'ka',
    'German': 'de',
    'Greek': 'el',
    'Guarani': 'gn',
    'Gujarati': 'gu',
    'Haitian Creole': 'ht',
    'Hakha Chin': 'cnh',
    'Hausa': 'ha',
    'Hawaiian': 'haw',
    'Hebrew': 'he',
    'Hiligaynon': 'hil',
    'Hindi': 'hi',
    'Hmong': 'hmn',
    'Hungarian': 'hu',
    'Hunsrik': 'hrx',
    'Icelandic': 'is',
    'Igbo': 'ig',
    'Iloko': 'ilo',
    'Indonesian': 'id',
    'Irish': 'ga',
    'Italian': 'it',
    'Japanese': 'ja',
    'Javanese': 'jv',
    'Kannada': 'kn',
    'Kapampangan': 'pam',
    'Kazakh': 'kk',
    'Khmer': 'km',
    'Kiga': 'cgg',
    'Kinyarwanda': 'rw',
    'Kituba': 'ktu',
    'Konkani': 'gom',
    'Korean': 'ko',
    'Krio': 'kri',
    'Kurdish (Kurmanji)': 'ku',
    'Kurdish (Sorani)': 'ckb',
    'Kyrgyz': 'ky',
    'Lao': 'lo',
    'Latgalian': 'ltg',
    'Latin': 'la',
    'Latvian': 'lv',
    'Ligurian': 'lij',
    'Limburgan': 'li',
    'Lingala': 'ln',
    'Lithuanian': 'lt',
    'Lombard': 'lmo',
    'Luo': 'luo',
    'Luxembourgish': 'lb',
    'Macedonian': 'mk',
    'Maithili': 'mai',
    'Makassar': 'mak',
    'Malagasy': 'mg',
    'Malay': 'ms',
    'Malay (Jawi)': 'ms-Arab',
    'Malayalam': 'ml',
    'Maltese': 'mt',
    'Maori': 'mi',
    'Marathi': 'mr',
    'Meadow Mari': 'chm',
    'Meiteilon (Manipuri)': 'mni-Mtei',
    'Minang': 'min',
    'Mizo': 'lus',
    'Mongolian': 'mn',
    'Myanmar (Burmese)': 'my',
    'Ndebele (South)': 'nr',
    'Nepalbhasa (Newari)': 'new',
    'Nepali': 'ne',
    'Northern Sotho (Sepedi)': 'nso',
    'Norwegian': 'no',
    'Nuer': 'nus',
    'Occitan': 'oc',
    'Odia (Oriya)': 'or',
    'Oromo': 'om',
    'Pangasinan': 'pag',
    'Papiamento': 'pap',
    'Pashto': 'ps',
    'Persian': 'fa',
    'Polish': 'pl',
    'Portuguese': 'pt',
    'Portuguese (Portugal)': 'pt-PT',
    'Portuguese (Brazil)': 'pt-BR',
    'Punjabi': 'pa',
    'Punjabi (Shahmukhi)': 'pa-Arab',
    'Quechua': 'qu',
    'Romani': 'rom',
    'Romanian': 'ro',
    'Rundi': 'rn',
    'Russian': 'ru',
    'Samoan': 'sm',
    'Sango': 'sg',
    'Sanskrit': 'sa',
    'Scots Gaelic': 'gd',
    'Serbian': 'sr',
    'Sesotho': 'st',
    'Seychellois Creole': 'crs',
    'Shan': 'shn',
    'Shona': 'sn',
    'Sicilian': 'scn',
    'Silesian': 'szl',
    'Sindhi': 'sd',
    'Sinhala (Sinhalese)': 'si',
    'Slovak': 'sk',
    'Slovenian': 'sl',
    'Somali': 'so',
    'Spanish': 'es',
    'Sundanese': 'su',
    'Swahili': 'sw',
    'Swati': 'ss',
    'Swedish': 'sv',
    'Tajik': 'tg',
    'Tamil': 'ta',
    'Tatar': 'tt',
    'Telugu': 'te',
    'Tetum': 'tet',
    'Thai': 'th',
    'Tigrinya': 'ti',
    'Tsonga': 'ts',
    'Tswana': 'tn',
    'Turkish': 'tr',
    'Turkmen': 'tk',
    'Twi (Akan)': 'ak',
    'Ukrainian': 'uk',
    'Urdu': 'ur',
    'Uyghur': 'ug',
    'Uzbek': 'uz',
    'Vietnamese': 'vi',
    'Welsh': 'cy',
    'Xhosa': 'xh',
    'Yiddish': 'yi',
    'Yoruba': 'yo',
    'Yucatec Maya': 'yua',
    'Zulu': 'zu'
}
const HostLanguage = Object.entries(Language).map(([label, value]) => ({ value, label }));

const checkProductImportTime = 5000; // 5 seconds

const allowedImageExtensions = ['jpg', 'jpeg', 'png', 'avif'];
const maxImageSize = 5 * 1024 * 1024; // 2MB

const profileImageMinWidth = 500
const profileImageMinHeight = 500

const coverImageMinWidth = 720
const coverImageMinHeight = 480

const meetingImageMinWidth = 1280
const meetingImageMinHeight = 720

const gallaryImageMinWidth = 1280
const gallaryImageMinHeight = 1280

const select2CustomStyles = {
    control: (base) => ({
        ...base,
        borderRadius: "10px", // Add border radius
        // borderColor: "##E6E8EC", // Optional: Customize border color
        border: "2px solid #E6E8EC",
        boxShadow: "none", // Remove the default focus box-shadow
        "&:hover": {
            borderColor: "#e3bd3e", // Change border color on hover
        },
        lineHeight: "2",
    }),
    menu: (base) => ({
        ...base,
        borderRadius: "10px", // Border radius for dropdown menu
        overflow: "hidden", // Ensure rounded corners for menu
        zIndex: 99999,
        "&:hover": {
            borderColor: "#e3bd3e", // Change border color on hover
        },
    }),
    option: (base, state) => ({
        ...base,
        borderRadius: "4px", // Option-level border radius (if needed)
        // backgroundColor: state.isFocused ? "#e3bd3e" : "white", // Background on hover
        backgroundColor: state.isSelected
            ? "#e3bd3e38"  // Yellow for selected option
            : state.isFocused
                ? "#f0f0f0" // Light gray when focused
                : "white",  // Default background for unselected options
        color: state.isSelected ? "black" : "black", // Ensure the text is readable
        "&:active": {
            backgroundColor: "#e3bd3e38", // Keep yellow background even when clicked
        },
        "&:focus": {
            backgroundColor: "#e3bd3e38", // Keep yellow background on focus
        },
        color: state.isFocused ? "#333" : "#000", // Text color
    }),
};

const countries = [
    { code: 'AF', name: 'AFGHANISTAN', phonecode: '93', iso_name: 'af' },
    { code: 'AL', name: 'ALBANIA', phonecode: '355', iso_name: 'al' },
    { code: 'DZ', name: 'ALGERIA', phonecode: '213', iso_name: 'dz' },
    { code: 'AS', name: 'AMERICAN SAMOA', phonecode: '1684', iso_name: 'as' },
    { code: 'AD', name: 'ANDORRA', phonecode: '376', iso_name: 'ad' },
    { code: 'AO', name: 'ANGOLA', phonecode: '244', iso_name: 'ao' },
    { code: 'AI', name: 'ANGUILLA', phonecode: '1264', iso_name: 'ai' },
    { code: 'AQ', name: 'ANTARCTICA', phonecode: '672', iso_name: 'aq' },
    { code: 'AG', name: 'ANTIGUA AND BARBUDA', phonecode: '1268', iso_name: 'ag' },
    { code: 'AR', name: 'ARGENTINA', phonecode: '54', iso_name: 'ar' },
    { code: 'AM', name: 'ARMENIA', phonecode: '374', iso_name: 'am' },
    { code: 'AW', name: 'ARUBA', phonecode: '297', iso_name: 'aw' },
    { code: 'AU', name: 'AUSTRALIA', phonecode: '61', iso_name: 'au' },
    { code: 'AT', name: 'AUSTRIA', phonecode: '43', iso_name: 'at' },
    { code: 'AZ', name: 'AZERBAIJAN', phonecode: '994', iso_name: 'az' },
    { code: 'BS', name: 'BAHAMAS', phonecode: '1242', iso_name: 'bs' },
    { code: 'BH', name: 'BAHRAIN', phonecode: '973', iso_name: 'bh' },
    { code: 'BD', name: 'BANGLADESH', phonecode: '880', iso_name: 'bd' },
    { code: 'BB', name: 'BARBADOS', phonecode: '1246', iso_name: 'bb' },
    { code: 'BY', name: 'BELARUS', phonecode: '375', iso_name: 'by' },
    { code: 'BE', name: 'BELGIUM', phonecode: '32', iso_name: 'be' },
    { code: 'BZ', name: 'BELIZE', phonecode: '501', iso_name: 'bz' },
    { code: 'BJ', name: 'BENIN', phonecode: '229', iso_name: 'bj' },
    { code: 'BM', name: 'BERMUDA', phonecode: '1441', iso_name: 'bm' },
    { code: 'BT', name: 'BHUTAN', phonecode: '975', iso_name: 'bt' },
    { code: 'BO', name: 'BOLIVIA', phonecode: '591', iso_name: 'bo' },
    { code: 'BA', name: 'BOSNIA AND HERZEGOVINA', phonecode: '387', iso_name: 'ba' },
    { code: 'BW', name: 'BOTSWANA', phonecode: '267', iso_name: 'bw' },
    { code: 'BV', name: 'BOUVET ISLAND', phonecode: '47', iso_name: 'bv' },
    { code: 'BR', name: 'BRAZIL', phonecode: '55', iso_name: 'br' },
    { code: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY', phonecode: '246', iso_name: 'io' },
    { code: 'BN', name: 'BRUNEI DARUSSALAM', phonecode: '673', iso_name: 'bn' },
    { code: 'BG', name: 'BULGARIA', phonecode: '359', iso_name: 'bg' },
    { code: 'BF', name: 'BURKINA FASO', phonecode: '226', iso_name: 'bf' },
    { code: 'BI', name: 'BURUNDI', phonecode: '257', iso_name: 'bi' },
    { code: 'KH', name: 'CAMBODIA', phonecode: '855', iso_name: 'kh' },
    { code: 'CM', name: 'CAMEROON', phonecode: '237', iso_name: 'cm' },
    { code: 'CA', name: 'CANADA', phonecode: '1', iso_name: 'ca' },
    { code: 'CV', name: 'CAPE VERDE', phonecode: '238', iso_name: 'cv' },
    { code: 'KY', name: 'CAYMAN ISLANDS', phonecode: '1345', iso_name: 'ky' },
    { code: 'CF', name: 'CENTRAL AFRICAN REPUBLIC', phonecode: '236', iso_name: 'cf' },
    { code: 'TD', name: 'CHAD', phonecode: '235', iso_name: 'td' },
    { code: 'CL', name: 'CHILE', phonecode: '56', iso_name: 'cl' },
    { code: 'CN', name: 'CHINA', phonecode: '86', iso_name: 'cn' },
    { code: 'CX', name: 'CHRISTMAS ISLAND', phonecode: '61', iso_name: 'cx' },
    { code: 'CC', name: 'COCOS ISLANDS', phonecode: '672', iso_name: 'cc' },
    { code: 'CO', name: 'COLOMBIA', phonecode: '57', iso_name: 'co' },
    { code: 'KM', name: 'COMOROS', phonecode: '269', iso_name: 'km' },
    { code: 'CG', name: 'CONGO', phonecode: '242', iso_name: 'cg' },
    { code: 'CD', name: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE', phonecode: '242', iso_name: 'cd' },
    { code: 'CK', name: 'COOK ISLANDS', phonecode: '682', iso_name: 'ck' },
    { code: 'CR', name: 'COSTA RICA', phonecode: '506', iso_name: 'cr' },
    { code: 'CI', name: "COTE D'IVOIRE", phonecode: '225', iso_name: 'ci' },
    { code: 'HR', name: 'CROATIA', phonecode: '385', iso_name: 'hr' },
    { code: 'CU', name: 'CUBA', phonecode: '53', iso_name: 'cu' },
    { code: 'CY', name: 'CYPRUS', phonecode: '357', iso_name: 'cy' },
    { code: 'CZ', name: 'CZECH REPUBLIC', phonecode: '420', iso_name: 'cz' },
    { code: 'DK', name: 'DENMARK', phonecode: '45', iso_name: 'dk' },
    { code: 'DJ', name: 'DJIBOUTI', phonecode: '253', iso_name: 'dj' },
    { code: 'DM', name: 'DOMINICA', phonecode: '1767', iso_name: 'dm' },
    { code: 'DO', name: 'DOMINICAN REPUBLIC', phonecode: '1809', iso_name: 'do' },
    { code: 'EC', name: 'ECUADOR', phonecode: '593', iso_name: 'ec' },
    { code: 'EG', name: 'EGYPT', phonecode: '20', iso_name: 'eg' },
    { code: 'SV', name: 'EL SALVADOR', phonecode: '503', iso_name: 'sv' },
    { code: 'GQ', name: 'EQUATORIAL GUINEA', phonecode: '240', iso_name: 'gq' },
    { code: 'ER', name: 'ERITREA', phonecode: '291', iso_name: 'er' },
    { code: 'EE', name: 'ESTONIA', phonecode: '372', iso_name: 'ee' },
    { code: 'ET', name: 'ETHIOPIA', phonecode: '251', iso_name: 'et' },
    { code: 'FK', name: 'FALKLAND ISLANDS', phonecode: '500', iso_name: 'fk' },
    { code: 'FO', name: 'FAROE ISLANDS', phonecode: '298', iso_name: 'fo' },
    { code: 'FJ', name: 'FIJI', phonecode: '679', iso_name: 'fj' },
    { code: 'FI', name: 'FINLAND', phonecode: '358', iso_name: 'fi' },
    { code: 'FR', name: 'FRANCE', phonecode: '33', iso_name: 'fr' },
    { code: 'GF', name: 'FRENCH GUIANA', phonecode: '594', iso_name: 'gf' },
    { code: 'PF', name: 'FRENCH POLYNESIA', phonecode: '689', iso_name: 'pf' },
    { code: 'TF', name: 'FRENCH SOUTHERN TERRITORIES', phonecode: '262', iso_name: 'tf' },
    { code: 'GA', name: 'GABON', phonecode: '241', iso_name: 'ga' },
    { code: 'GM', name: 'GAMBIA', phonecode: '220', iso_name: 'gm' },
    { code: 'GE', name: 'GEORGIA', phonecode: '995', iso_name: 'ge' },
    { code: 'DE', name: 'GERMANY', phonecode: '49', iso_name: 'de' },
    { code: 'GH', name: 'GHANA', phonecode: '233', iso_name: 'gh' },
    { code: 'GI', name: 'GIBRALTAR', phonecode: '350', iso_name: 'gi' },
    { code: 'GR', name: 'GREECE', phonecode: '30', iso_name: 'gr' },
    { code: 'GL', name: 'GREENLAND', phonecode: '299', iso_name: 'gl' },
    { code: 'GD', name: 'GRENADA', phonecode: '1473', iso_name: 'gd' },
    { code: 'GP', name: 'GUADELOUPE', phonecode: '590', iso_name: 'gp' },
    { code: 'GU', name: 'GUAM', phonecode: '1671', iso_name: 'gu' },
    { code: 'GT', name: 'GUATEMALA', phonecode: '502', iso_name: 'gt' },
    { code: 'GG', name: 'GUERNSEY', phonecode: '44', iso_name: 'gg' },
    { code: 'GN', name: 'GUINEA', phonecode: '224', iso_name: 'gn' },
    { code: 'GW', name: 'GUINEA-BISSAU', phonecode: '245', iso_name: 'gw' },
    { code: 'GY', name: 'GUYANA', phonecode: '592', iso_name: 'gy' },
    { code: 'HT', name: 'HAITI', phonecode: '509', iso_name: 'ht' },
    { code: 'HM', name: 'HEARD ISLAND AND MCDONALD ISLANDS', phonecode: '672', iso_name: 'hm' },
    { code: 'VA', name: 'HOLY SEE (VATICAN CITY STATE)', phonecode: '379', iso_name: 'va' },
    { code: 'HN', name: 'HONDURAS', phonecode: '504', iso_name: 'hn' },
    { code: 'HK', name: 'HONG KONG', phonecode: '852', iso_name: 'hk' },
    { code: 'HU', name: 'HUNGARY', phonecode: '36', iso_name: 'hu' },
    { code: 'IS', name: 'ICELAND', phonecode: '354', iso_name: 'is' },
    { code: 'IN', name: 'INDIA', phonecode: '91', iso_name: 'in' },
    { code: 'ID', name: 'INDONESIA', phonecode: '62', iso_name: 'id' },
    { code: 'IR', name: 'IRAN', phonecode: '98', iso_name: 'ir' },
    { code: 'IQ', name: 'IRAQ', phonecode: '964', iso_name: 'iq' },
    { code: 'IE', name: 'IRELAND', phonecode: '353', iso_name: 'ie' },
    { code: 'IM', name: 'ISLE OF MAN', phonecode: '44', iso_name: 'im' },
    { code: 'IL', name: 'ISRAEL', phonecode: '972', iso_name: 'il' },
    { code: 'IT', name: 'ITALY', phonecode: '39', iso_name: 'it' },
    { code: 'JM', name: 'JAMAICA', phonecode: '1876', iso_name: 'jm' },
    { code: 'JP', name: 'JAPAN', phonecode: '81', iso_name: 'jp' },
    { code: 'JE', name: 'JERSEY', phonecode: '44', iso_name: 'je' },
    { code: 'JO', name: 'JORDAN', phonecode: '962', iso_name: 'jo' },
    { code: 'KZ', name: 'KAZAKHSTAN', phonecode: '7', iso_name: 'kz' },
    { code: 'KE', name: 'KENYA', phonecode: '254', iso_name: 'ke' },
    { code: 'KI', name: 'KIRIBATI', phonecode: '686', iso_name: 'ki' },
    { code: 'KP', name: 'KOREA (NORTH)', phonecode: '850', iso_name: 'kp' },
    { code: 'KR', name: 'KOREA (SOUTH)', phonecode: '82', iso_name: 'kr' },
    { code: 'KW', name: 'KUWAIT', phonecode: '965', iso_name: 'kw' },
    { code: 'KG', name: 'KYRGYZSTAN', phonecode: '996', iso_name: 'kg' },
    { code: 'LA', name: 'LAOS', phonecode: '856', iso_name: 'la' },
    { code: 'LV', name: 'LATVIA', phonecode: '371', iso_name: 'lv' },
    { code: 'LB', name: 'LEBANON', phonecode: '961', iso_name: 'lb' },
    { code: 'LS', name: 'LESOTHO', phonecode: '266', iso_name: 'ls' },
    { code: 'LR', name: 'LIBERIA', phonecode: '231', iso_name: 'lr' },
    { code: 'LY', name: 'LIBYA', phonecode: '218', iso_name: 'ly' },
    { code: 'LI', name: 'LIECHTENSTEIN', phonecode: '423', iso_name: 'li' },
    { code: 'LT', name: 'LITHUANIA', phonecode: '370', iso_name: 'lt' },
    { code: 'LU', name: 'LUXEMBOURG', phonecode: '352', iso_name: 'lu' },
    { code: 'MO', name: 'MACAO', phonecode: '853', iso_name: 'mo' },
    { code: 'MK', name: 'MACEDONIA', phonecode: '389', iso_name: 'mk' },
    { code: 'MG', name: 'MADAGASCAR', phonecode: '261', iso_name: 'mg' },
    { code: 'MW', name: 'MALAWI', phonecode: '265', iso_name: 'mw' },
    { code: 'MY', name: 'MALAYSIA', phonecode: '60', iso_name: 'my' },
    { code: 'MV', name: 'MALDIVES', phonecode: '960', iso_name: 'mv' },
    { code: 'ML', name: 'MALI', phonecode: '223', iso_name: 'ml' },
    { code: 'MT', name: 'MALTA', phonecode: '356', iso_name: 'mt' },
    { code: 'MH', name: 'MARSHALL ISLANDS', phonecode: '692', iso_name: 'mh' },
    { code: 'MQ', name: 'MARTINIQUE', phonecode: '596', iso_name: 'mq' },
    { code: 'MR', name: 'MAURITANIA', phonecode: '222', iso_name: 'mr' },
    { code: 'MU', name: 'MAURITIUS', phonecode: '230', iso_name: 'mu' },
    { code: 'YT', name: 'MAYOTTE', phonecode: '262', iso_name: 'yt' },
    { code: 'MX', name: 'MEXICO', phonecode: '52', iso_name: 'mx' },
    { code: 'FM', name: 'MICRONESIA', phonecode: '691', iso_name: 'fm' },
    { code: 'MD', name: 'MOLDOVA', phonecode: '373', iso_name: 'md' },
    { code: 'MC', name: 'MONACO', phonecode: '377', iso_name: 'mc' },
    { code: 'MN', name: 'MONGOLIA', phonecode: '976', iso_name: 'mn' },
    { code: 'ME', name: 'MONTENEGRO', phonecode: '382', iso_name: 'me' },
    { code: 'MS', name: 'MONTSERRAT', phonecode: '1664', iso_name: 'ms' },
    { code: 'MA', name: 'MOROCCO', phonecode: '212', iso_name: 'ma' },
    { code: 'MZ', name: 'MOZAMBIQUE', phonecode: '258', iso_name: 'mz' },
    { code: 'MM', name: 'MYANMAR', phonecode: '95', iso_name: 'mm' },
    { code: 'NA', name: 'NAMIBIA', phonecode: '264', iso_name: 'na' },
    { code: 'NR', name: 'NAURU', phonecode: '674', iso_name: 'nr' },
    { code: 'NP', name: 'NEPAL', phonecode: '977', iso_name: 'np' },
    { code: 'NL', name: 'NETHERLANDS', phonecode: '31', iso_name: 'nl' },
    { code: 'NC', name: 'NEW CALEDONIA', phonecode: '687', iso_name: 'nc' },
    { code: 'NZ', name: 'NEW ZEALAND', phonecode: '64', iso_name: 'nz' },
    { code: 'NI', name: 'NICARAGUA', phonecode: '505', iso_name: 'ni' },
    { code: 'NE', name: 'NIGER', phonecode: '227', iso_name: 'ne' },
    { code: 'NG', name: 'NIGERIA', phonecode: '234', iso_name: 'ng' },
    { code: 'NU', name: 'NIUE', phonecode: '683', iso_name: 'nu' },
    { code: 'NF', name: 'NORFOLK ISLAND', phonecode: '672', iso_name: 'nf' },
    { code: 'MP', name: 'NORTHERN MARIANA ISLANDS', phonecode: '1670', iso_name: 'mp' },
    { code: 'NO', name: 'NORWAY', phonecode: '47', iso_name: 'no' },
    { code: 'OM', name: 'OMAN', phonecode: '968', iso_name: 'om' },
    { code: 'PK', name: 'PAKISTAN', phonecode: '92', iso_name: 'pk' },
    { code: 'PW', name: 'PALAU', phonecode: '680', iso_name: 'pw' },
    { code: 'PS', name: 'PALESTINE', phonecode: '970', iso_name: 'ps' },
    { code: 'PA', name: 'PANAMA', phonecode: '507', iso_name: 'pa' },
    { code: 'PG', name: 'PAPUA NEW GUINEA', phonecode: '675', iso_name: 'pg' },
    { code: 'PY', name: 'PARAGUAY', phonecode: '595', iso_name: 'py' },
    { code: 'PE', name: 'PERU', phonecode: '51', iso_name: 'pe' },
    { code: 'PH', name: 'PHILIPPINES', phonecode: '63', iso_name: 'ph' },
    { code: 'PN', name: 'PITCAIRN', phonecode: '64', iso_name: 'pn' },
    { code: 'PL', name: 'POLAND', phonecode: '48', iso_name: 'pl' },
    { code: 'PT', name: 'PORTUGAL', phonecode: '351', iso_name: 'pt' },
    { code: 'PR', name: 'PUERTO RICO', phonecode: '1939', iso_name: 'pr' },
    { code: 'QA', name: 'QATAR', phonecode: '974', iso_name: 'qa' },
    { code: 'RE', name: 'REUNION', phonecode: '262', iso_name: 're' },
    { code: 'RO', name: 'ROMANIA', phonecode: '40', iso_name: 'ro' },
    { code: 'RU', name: 'RUSSIA', phonecode: '7', iso_name: 'ru' },
    { code: 'RW', name: 'RWANDA', phonecode: '250', iso_name: 'rw' },
    { code: 'BL', name: 'SAINT BARTHELEMY', phonecode: '590', iso_name: 'bl' },
    { code: 'SH', name: 'SAINT HELENA', phonecode: '290', iso_name: 'sh' },
    { code: 'KN', name: 'SAINT KITTS AND NEVIS', phonecode: '1869', iso_name: 'kn' },
    { code: 'LC', name: 'SAINT LUCIA', phonecode: '1758', iso_name: 'lc' },
    { code: 'MF', name: 'SAINT MARTIN', phonecode: '590', iso_name: 'mf' },
    { code: 'PM', name: 'SAINT PIERRE AND MIQUELON', phonecode: '508', iso_name: 'pm' },
    { code: 'VC', name: 'SAINT VINCENT AND THE GRENADINES', phonecode: '1784', iso_name: 'vc' },
    { code: 'WS', name: 'SAMOA', phonecode: '685', iso_name: 'ws' },
    { code: 'SM', name: 'SAN MARINO', phonecode: '378', iso_name: 'sm' },
    { code: 'ST', name: 'SAO TOME AND PRINCIPE', phonecode: '239', iso_name: 'st' },
    { code: 'SA', name: 'SAUDI ARABIA', phonecode: '966', iso_name: 'sa' },
    { code: 'SN', name: 'SENEGAL', phonecode: '221', iso_name: 'sn' },
    { code: 'RS', name: 'SERBIA', phonecode: '381', iso_name: 'rs' },
    { code: 'SC', name: 'SEYCHELLES', phonecode: '248', iso_name: 'sc' },
    { code: 'SL', name: 'SIERRA LEONE', phonecode: '232', iso_name: 'sl' },
    { code: 'SG', name: 'SINGAPORE', phonecode: '65', iso_name: 'sg' },
    { code: 'SX', name: 'SINT MAARTEN', phonecode: '1721', iso_name: 'sx' },
    { code: 'SK', name: 'SLOVAKIA', phonecode: '421', iso_name: 'sk' },
    { code: 'SI', name: 'SLOVENIA', phonecode: '386', iso_name: 'si' },
    { code: 'SB', name: 'SOLOMON ISLANDS', phonecode: '677', iso_name: 'sb' },
    { code: 'SO', name: 'SOMALIA', phonecode: '252', iso_name: 'so' },
    { code: 'ZA', name: 'SOUTH AFRICA', phonecode: '27', iso_name: 'za' },
    { code: 'SS', name: 'SOUTH SUDAN', phonecode: '211', iso_name: 'ss' },
    { code: 'ES', name: 'SPAIN', phonecode: '34', iso_name: 'es' },
    { code: 'LK', name: 'SRI LANKA', phonecode: '94', iso_name: 'lk' },
    { code: 'SD', name: 'SUDAN', phonecode: '249', iso_name: 'sd' },
    { code: 'SR', name: 'SURINAME', phonecode: '597', iso_name: 'sr' },
    { code: 'SE', name: 'SWEDEN', phonecode: '46', iso_name: 'se' },
    { code: 'CH', name: 'SWITZERLAND', phonecode: '41', iso_name: 'ch' },
    { code: 'SY', name: 'SYRIA', phonecode: '963', iso_name: 'sy' },
    { code: 'TW', name: 'TAIWAN', phonecode: '886', iso_name: 'tw' },
    { code: 'TJ', name: 'TAJIKISTAN', phonecode: '992', iso_name: 'tj' },
    { code: 'TZ', name: 'TANZANIA', phonecode: '255', iso_name: 'tz' },
    { code: 'TH', name: 'THAILAND', phonecode: '66', iso_name: 'th' },
    { code: 'TL', name: 'TIMOR-LESTE', phonecode: '670', iso_name: 'tl' },
    { code: 'TG', name: 'TOGO', phonecode: '228', iso_name: 'tg' },
    { code: 'TK', name: 'TOKELAU', phonecode: '690', iso_name: 'tk' },
    { code: 'TO', name: 'TONGA', phonecode: '676', iso_name: 'to' },
    { code: 'TT', name: 'TRINIDAD AND TOBAGO', phonecode: '1868', iso_name: 'tt' },
    { code: 'TN', name: 'TUNISIA', phonecode: '216', iso_name: 'tn' },
    { code: 'TR', name: 'TURKEY', phonecode: '90', iso_name: 'tr' },
    { code: 'TM', name: 'TURKMENISTAN', phonecode: '993', iso_name: 'tm' },
    { code: 'TC', name: 'TURKS AND CAICOS ISLANDS', phonecode: '1649', iso_name: 'tc' },
    { code: 'TV', name: 'TUVALU', phonecode: '688', iso_name: 'tv' },
    { code: 'UG', name: 'UGANDA', phonecode: '256', iso_name: 'ug' },
    { code: 'UA', name: 'UKRAINE', phonecode: '380', iso_name: 'ua' },
    { code: 'AE', name: 'UNITED ARAB EMIRATES', phonecode: '971', iso_name: 'ae' },
    { code: 'GB', name: 'UNITED KINGDOM', phonecode: '44', iso_name: 'gb' },
    { code: 'US', name: 'UNITED STATES', phonecode: '1', iso_name: 'us' },
    { code: 'UY', name: 'URUGUAY', phonecode: '598', iso_name: 'uy' },
    { code: 'UZ', name: 'UZBEKISTAN', phonecode: '998', iso_name: 'uz' },
    { code: 'VU', name: 'VANUATU', phonecode: '678', iso_name: 'vu' },
    { code: 'VE', name: 'VENEZUELA', phonecode: '58', iso_name: 've' },
    { code: 'VN', name: 'VIETNAM', phonecode: '84', iso_name: 'vn' },
    { code: 'WF', name: 'WALLIS AND FUTUNA', phonecode: '681', iso_name: 'wf' },
    { code: 'EH', name: 'WESTERN SAHARA', phonecode: '212', iso_name: 'eh' },
    { code: 'YE', name: 'YEMEN', phonecode: '967', iso_name: 'ye' },
    { code: 'ZM', name: 'ZAMBIA', phonecode: '260', iso_name: 'zm' },
    { code: 'ZW', name: 'ZIMBABWE', phonecode: '263', iso_name: 'zw' }



]


const AllPermissions = {

    "COMPANY": ["VIEW", "EDIT"],

    "PROFILE": ["VIEW", "EDIT"],

    "PRODUCTS": ["VIEW", "CREATE", "EDIT", "DELETE"],

    "BOOKINGS": ["VIEW"],

    "AVAILABILITY": ["VIEW"],

    "TEAM": ["VIEW", "CREATE", "EDIT", "DELETE"],

    "PRIVACY": ["VIEW"],

    "PROMOTION": ["VIEW", "CREATE", "EDIT", "DELETE"],

    "FINANCE": ["PAYMENTS", "WITHDRAWALS"],



}

const RoutePermissions = {

    '/company-info': 'COMPANY-VIEW',

    '/profile': 'PROFILE-VIEW',
    '/profile': 'PROFILE-EDIT',

    '/products': 'PRODUCTS-VIEW',
    '/product/import': 'PRODUCTS-CREATE',
    '/product/edit/:slug': 'PRODUCTS-EDIT',

    '/bookings': 'BOOKINGS-VIEW',

    '/availability': 'AVAILABILITY-VIEW',

    '/team': 'TEAM-VIEW',

    '/privacy': 'PRIVACY-VIEW',

    '/finance/payments': 'FINANCE-PAYMENTS',
    '/finance/withdrawals': 'FINANCE-WITHDRAWALS',
    '/finance/withdrawals/:id': 'FINANCE-WITHDRAWALS',

    '/temporary-discounts': 'PROMOTION-VIEW',

}


const ModeratorPermissions = {

    "COMPANY": ["VIEW"],

    "PROFILE": ["VIEW", "EDIT"],

    "PRODUCTS": ["VIEW", "CREATE", "EDIT", "DELETE"],

    "BOOKINGS": ["VIEW"],

    "AVAILABILITY": ["VIEW"],

    // "TEAM": ["VIEW", "CREATE", "EDIT", "DELETE", "STATUS"],

    "PRIVACY": ["VIEW"],

    "PROMOTION": ["VIEW", "CREATE", "EDIT", "DELETE"],


}


const footerSocialUrl = {
    "footer_social_facebook_profile_url": <i className="fa-brands fa-facebook-f"></i>,
    "footer_social_instagram_profile_url": <i className="fa-brands fa-instagram"></i>,
    "footer_social_linkedin_profile_url": <i className="fa-brands fa-linkedin-in"></i>,
    "footer_social_mastodon_profile_url": <i className="fa-brands fa-mastodon"></i>,
    "footer_social_myspace_profile_url": <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-2 -2 24 24"><g fill="currentColor"><path d="M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10" /><ellipse cx="6.418" cy="9.443" rx="1.288" ry="1.275" /><path d="M6.4 11.051c-.78.01-1.4.654-1.4 1.426v.359c0 .083.068.15.152.15h2.531a.15.15 0 0 0 .152-.15v-.382A1.41 1.41 0 0 0 6.4 11.051" /><ellipse cx="9.68" cy="9.151" rx="1.394" ry="1.38" /><path d="M9.661 10.892a1.54 1.54 0 0 0-1.515 1.543v.4c0 .084.068.151.152.151h2.764a.15.15 0 0 0 .153-.15v-.425c0-.845-.698-1.53-1.554-1.519m3.582-.717c.882 0 1.597-.708 1.597-1.581s-.715-1.58-1.597-1.58s-1.597.707-1.597 1.58s.715 1.58 1.597 1.58zm0 .413c-.97 0-1.757.779-1.757 1.74v.508c0 .083.068.15.152.15h3.21a.15.15 0 0 0 .152-.15v-.509c0-.96-.787-1.74-1.757-1.74z" /></g></svg>,
    "footer_social_pinterest_profile_url": <i className="fa-brands fa-pinterest"></i>,
    "footer_social_soundcloud_profile_url": <i className="fa-brands fa-soundcloud"></i>,
    "footer_social_tiktok_profile_url": <i className="fa-brands fa-tiktok"></i>,
    "footer_social_tumblr_profile_url": <i className="fa-brands fa-tumblr"></i>,
    "footer_social_twitter_username": <i className="fa-brands fa-x-twitter"></i>,
    "footer_social_wikipedia_page": <i className="fa-brands fa-wikipedia-w"></i>,
    "footer_social_youtube_profile_url": <i className="fa-brands fa-youtube"></i>
}

const TourProviders = ["Bokun"]

const brandLogos = {
    visa: "https://img.icons8.com/color/48/visa.png",
    mastercard: "https://img.icons8.com/color/48/mastercard.png",
    amex: "https://img.icons8.com/color/48/amex.png",
    discover: "https://img.icons8.com/color/48/discover.png",
    diners: "https://img.icons8.com/color/48/diners-club.png",
    jcb: "https://img.icons8.com/color/48/jcb.png",
    unionpay: "https://img.icons8.com/color/48/unionpay.png",
    unknown: "https://img.icons8.com/ios/50/bank-card-back-side.png",
};

export {
    SidebarConfig,
    DescriptionLanguage,
    HostLanguage,
    allowedImageExtensions,
    maxImageSize,
    checkProductImportTime,
    select2CustomStyles,
    countries,
    profileImageMinWidth,
    profileImageMinHeight,
    coverImageMinWidth,
    coverImageMinHeight,
    meetingImageMinWidth,
    meetingImageMinHeight,
    gallaryImageMinHeight,
    gallaryImageMinWidth,
    Language,
    AllPermissions,
    RoutePermissions,
    ModeratorPermissions,
    footerSocialUrl,
    TourProviders,
    brandLogos
};